import type { Formula } from "building-types/options/formula";
import type { Table } from "common/data/table";

export function removeDisabledEntities<E extends { disabled?: Formula | boolean }>(entities: Table<E>): Table<E> {
  const filtered = {};
  for (const entityId in entities) {
    const entity = entities[entityId];
    if (!entity) {
      continue;
    }

    if (entity.disabled) {
      continue;
    }

    filtered[entityId] = entity;
  }

  return filtered;
}
